import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n';
import * as core from './assets/js/core'

Vue.prototype.$core = core

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
